var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-expansion-panels",
    [
      _c(
        "v-expansion-panel",
        [
          _c(
            "v-expansion-panel-header",
            {
              staticClass: "pa-4",
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function() {
                    return [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v(
                          "\n                    $mdiChevronDown\n                "
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("div", { staticClass: "d-flex align-center" }, [
                _c(
                  "div",
                  { staticClass: "icon-circle" },
                  [
                    _c("v-icon", { attrs: { color: "primary", large: "" } }, [
                      _vm._v(
                        "\n                        $mdiFormatListCheckbox\n                    "
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("h3", { staticClass: "primary--text title ml-3" }, [
                  _vm._v(
                    "\n                    Summary of Offer\n                "
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "v-expansion-panel-content",
            [_c("attributes", { attrs: { small: "" } })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }